import React from 'react';
import { Button } from '@aibuild/ui';
import {
  StateActions,
  StateBody,
  StateTitle,
  StateWrap,
} from './ProcessesStates.styled';

export interface ProcessesErrorProps {
  error: Error;
  onRetry: () => void;
  dataTestId?: string;
}

const ProcessesError: React.FC<ProcessesErrorProps> = ({
  error,
  onRetry,
  dataTestId = 'processes-error',
}) => (
  // `role="alert"` + `aria-live="assertive"` so screen readers announce the
  // failure as soon as it appears (the list silently disappearing without an
  // announcement is the worst case for a SR user).
  <StateWrap role="alert" aria-live="assertive" data-testid={dataTestId}>
    <StateTitle>Couldn’t load your processes</StateTitle>
    <StateBody>
      {error.message ||
        'Something went wrong fetching the processes list. Please try again.'}
    </StateBody>
    <StateActions>
      <Button
        variant="outlined"
        onClick={onRetry}
        dataTestId={`${dataTestId}__retry`}
      >
        Retry
      </Button>
    </StateActions>
  </StateWrap>
);

export default ProcessesError;
